import * as angular from 'angular';

import { ComponentDefinition, IApiInformation } from '../../../models';
import { ISingleSignOnService } from '../../../services/general/singleSignOn.service';
import { StoreElement } from '../../../stateManagement';
import { IStoreService } from '../../../services';

class SSOController implements angular.IComponentController, angular.IOnDestroy {

    isLoading: boolean = true;
    loadingMessage: string = 'Authenticating user using Single-Sign-On';
    apiInformation: IApiInformation;

    private _unsubscribe: () => void;

    static $inject = ['$q', '$translate', '$state', 'storeService', 'singleSignOnService'];

    constructor(
        private _$q: angular.IQService,
        private _$translate: angular.translate.ITranslateService,
        private _$state: angular.ui.IStateService,
        private _storeService: IStoreService,
        private _singleSignOnService: ISingleSignOnService
    ) {
    }

    $onInit() {
        this.loadingMessage = this._$translate.instant(this.loadingMessage);

        const defer = this._$q.defer<void>();

        this._unsubscribe = this._storeService.register(store => {
            this.apiInformation = store.apiInformation.value;
            defer.resolve();
        }, [StoreElement.ApiInformation]);

        defer.promise
            .then(() => this._singleSignOnService.login())
            .then(to => {
                if (!this.apiInformation.isLicenseValid) {
                    to = { url: 'administration', params: {} };
                } else if (!to) {
                    to = { url: 'workspace', params: {} };
                }
                this._$state.go(to.url, to.params);
            })
            .catch(reason => {
                let msg;
                try {
                    msg = reason.data.error_description;
                } catch { /* empty */ }
                console.error(msg);
                this._$state.go('login', { message: msg });
            })
            .finally(() => this.isLoading = false);
    }

    $onDestroy(): void {
        if (this._unsubscribe) {
            this._unsubscribe();
        }
    }
}

export const singleSignOn: ComponentDefinition = {
    componentId: 'wtSingleSignOn',
    controller: SSOController,
    template: require('./singleSignOn.component.html'),
    controllerAs: 'vm',
    bindings: {

    }
};